import { React, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

import ForgetSenderPassword from "./ForgetSenderPassword";
import ForgetTravelerPassword from "./ForgetTravelerPassword";
import { useModal } from '../../ModalContext';


const Forgot = () => {
  const {handleFirstModalOpen } = useModal();



  return (
    <>
      <main className="bg-white">
        <section className="p-3 login-page">
          <Row className="work-box rounded-0 border-0 justify-content-center align-items-center">
          <ForgetSenderPassword handleFirstModalOpen={handleFirstModalOpen} />

          </Row>
        </section>
      </main>
    </>
  );
};

export default Forgot;
